import React, { FC } from "react";
import WithAuth from "../../Hoc/WithAuth";

const OurTeam: FC = () => {
  return <section>Our Team</section>;
};

export default WithAuth(OurTeam);
